import axios from "../../utils/axios";

export const getUnlikes = async (obj) => {
    
    const response = await axios.patch(`/videos/${obj.id}`, {
            unlikes:obj.unlikesLocal,
        }, {
            headers: { 'Content-type': 'application/json; charset=UTF-8' }
        });

    

    return  response.data;
};


